import { AllocationViewActionIdentifierModel } from '../../models';

export class AllocationViewDeleteAction {
  public static readonly type = '[AllocationViewDeleteAction] ULI Delete';

  constructor(
    public payload: {
      identifier: AllocationViewActionIdentifierModel;
    },
  ) {}
}

export class AllocationViewDeleteSetInitialState {
  public static readonly type = '[AllocationViewDeleteAction] Set Initial State';
}
